export default __webpack_public_path__ + "39fd83bce9cd409f08782b41db15d836.png";